import type { ThunkResult } from "src/app/reducers/IMainAppState";
import { APIGetAxios } from "./FetchActions";
import { UTILS_API_PATH } from "src/confs/APIConfig";
import type { AxiosResponse } from "axios";
import TermTemplate from "src/shared/term/objects/TermTemplate";
import type TermNameType from "src/shared/term/objects/TermNameType";

export function LoadTermTemplates(
  termName: TermNameType,
  countryCode: string,
): ThunkResult<Promise<TermTemplate[]>> {
  return async (dispatch) => {
    const fetchResult: AxiosResponse = await dispatch(
      APIGetAxios(`${UTILS_API_PATH}/${termName}/${countryCode}`),
    );
    return fetchResult.data.map((termTemplateJson: any) => {
      return new TermTemplate(termTemplateJson);
    });
  };
}
